module.exports = __webpack_public_path__ + "img/box-title-2.d983eae9.png";